import LoanDetailsContainer from 'containers/Microloans/ApplyLoan';

export default {
  exact: true,
  name: 'Apply-loan',
  protected: true,
  path: '/apply-loan',
  component: LoanDetailsContainer,
};
